// extracted by mini-css-extract-plugin
export default {"main":"CourseTitle_main__1FPyk","heading":"CourseTitle_heading__3Llv0","img_container":"CourseTitle_img_container__sM92f","cross":"CourseTitle_cross__88zoj"};